var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.test)?_c('div',[_c('signature',{on:{"closePop":_vm.closePop,"saveImg":_vm.complete}})],1):_c('van-empty',{staticClass:"custom-image",attrs:{"image":require('../../assets/images/check-circle-fill@3x.png'),"description":_vm.description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }